import { Paper, Stack, Transition } from "@mantine/core";

import type { ChatListProps } from "./ChatQueue/FlatChatList";

import classes from "./chat-components.module.css";
import { FlatChatList } from "./ChatQueue/FlatChatList";

export function ChatQueue({ chats, ...rest }: ChatListProps) {
    return (
        <Transition mounted={chats.length > 0} transition="fade-right">
            {(transitionStyle) => (
                <Paper
                    id="chat-queue"
                    pos="absolute"
                    h="100%"
                    w="100%"
                    component="aside"
                    radius="0"
                    bg="var(--exwo-color-panel-bg)"
                    className={classes.chat_queue}
                    style={{ ...transitionStyle }}
                >
                    <Stack component="nav" gap="0">
                        <FlatChatList chats={chats} {...rest} />
                    </Stack>
                </Paper>
            )}
        </Transition>
    );
}
